import React, { FC } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import i18n from 'i18n-js';
import { font } from '@styles/fonts';
import { scale } from '@components/frame';
import { CategorySectionProps } from '@components/ncFileVersions/components/NCFileDiffView/ChangeSummaryPanel/types';
import {
  CATEGORY_COLOR_TOKEN,
  CATEGORY_DOT_SIZE,
  CATEGORY_TITLE_KEY,
  ENTRY_GRID_GAP,
} from '../../constants/changeSummaryPanel.constants';
import SummaryEntryRow from '@components/ncFileVersions/components/NCFileDiffView/ChangeSummaryPanel/components/SummaryEntryRow';

const CategorySection: FC<CategorySectionProps> = ({ C, category, entries, totalCount, itemWidth, onJumpToChange }) => {
  const title = i18n.t(CATEGORY_TITLE_KEY[category]);
  const overflow = totalCount - entries.length;
  const slotStyle = itemWidth > 0 ? { width: itemWidth } : styles.entrySlotFallback;
  return (
    <View style={styles.section}>
      <View style={styles.sectionHeader}>
        <View style={[styles.dot, { backgroundColor: C(CATEGORY_COLOR_TOKEN[category]) }]} />
        <Text style={[font.Headline, { color: C('Label/Light/Primary') }]}>{title}</Text>
        <Text style={[font['Subhead 2'], styles.sectionCount, { color: C('Label/Light/Tertiary') }]}>{totalCount}</Text>
      </View>
      <View style={styles.entriesGrid}>
        {entries.map((entry) => (
          <View key={entry.id} style={slotStyle}>
            <SummaryEntryRow C={C} entry={entry} onJumpToChange={onJumpToChange} />
          </View>
        ))}
        {overflow > 0 && (
          <Text style={[font['Subhead 2'], styles.overflowText, { color: C('Label/Light/Tertiary') }]}>
            {i18n.t('{{count}} more', { count: overflow })}
          </Text>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  section: {
    gap: scale(8),
  },
  sectionHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: scale(8),
  },
  sectionCount: {
    marginLeft: scale(4),
  },
  entriesGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: scale(ENTRY_GRID_GAP),
  },
  entrySlotFallback: {
    width: '100%',
  },
  overflowText: {
    width: '100%',
    paddingHorizontal: scale(8),
    paddingVertical: scale(4),
  },
  dot: {
    width: scale(CATEGORY_DOT_SIZE),
    height: scale(CATEGORY_DOT_SIZE),
    borderRadius: scale(CATEGORY_DOT_SIZE) / 2,
  },
});

export default CategorySection;
